var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 9,
    viewBox: "0 0 10 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.20487 0.580725C3.54914 0.864976 3.0687 1.79838 2.10781 3.6652C1.2784 5.27657 0.8637 6.08226 0.973215 6.73711C1.05827 7.2457 1.33647 7.70178 1.74974 8.01016C2.28187 8.40723 3.18802 8.40723 5.00033 8.40723C6.81263 8.40723 7.71878 8.40723 8.25091 8.01016C8.66419 7.70178 8.94238 7.2457 9.02744 6.73711C9.13695 6.08226 8.72225 5.27657 7.89284 3.6652C6.93195 1.79838 6.45151 0.864976 5.79578 0.580725C5.28829 0.360732 4.71236 0.360732 4.20487 0.580725Z",
    fill: "#52B3A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayUp);
export default __webpack_public_path__ + "static/media/play-up.38d9842ed3b0a0335ca2d8a9b340bfd2.svg";
export { ForwardRef as ReactComponent };